import { useConfig } from 'providers/config/ConfigProvider';
import styles from './takeover-modal-page-header.module.scss';
import { useGetBranding } from '@sanlam-glacier/app-common/modules/theme';
import { Divider, Typography } from '@sanlam-glacier/app-common/components';

type TakeoverModalPageHeaderProps = {
  clientName: string;
  modalHeading: string;
};

const TakeoverModalPageHeader = ({ clientName, modalHeading }: TakeoverModalPageHeaderProps) => {
  const { theme } = useConfig();
  const { glacierLogoColor, brandLogoColor } = useGetBranding(theme);
  const testComponentName = 'takeoverLogo';
  return (
    <div className={styles.modalHeading}>
      <div className={styles.logoContainer}>
        <img
          data-testid={`${testComponentName}SanlamGlacierLogo`}
          alt='Sanlam Glacier'
          className={styles.topBarIcon}
          src={glacierLogoColor}
        />
        {brandLogoColor && (
          <>
            <div className={styles.logoDivider} />
            <img
              data-testid={`${testComponentName}PartnerLogo`}
              alt='Brand'
              className={styles.brandLogo}
              src={brandLogoColor}
            />
          </>
        )}
      </div>
      <div className={styles.rightSideOfModalHeading}>
        <div className={styles.statementAndClientInfo}>
          <Typography
            variant={Typography.VARIANT.B3}
            color={Typography.COLOR.PRIMARY}
            weight={Typography.WEIGHT.MEDIUM}
            align={Typography.ALIGN.RIGHT}
          >
            {modalHeading}
          </Typography>
          <Typography
            variant={Typography.VARIANT.B4}
            color={Typography.COLOR.PRIMARY}
            weight={Typography.WEIGHT.NORMAL}
            align={Typography.ALIGN.RIGHT}
          >
            {clientName}
          </Typography>
        </div>
        <Divider position={Divider.POSITION.VERTICAL} className={styles.rightDivider} />
      </div>
    </div>
  );
};

export default TakeoverModalPageHeader;
